import { render, staticRenderFns } from "./SimpleQuickStatistics.vue?vue&type=template&id=452f0548&scoped=true&"
import script from "./SimpleQuickStatistics.vue?vue&type=script&lang=js&"
export * from "./SimpleQuickStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SimpleQuickStatistics.vue?vue&type=style&index=0&id=452f0548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f0548",
  null
  
)

/* custom blocks */
import block0 from "./SimpleQuickStatistics.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('452f0548')) {
      api.createRecord('452f0548', component.options)
    } else {
      api.reload('452f0548', component.options)
    }
    module.hot.accept("./SimpleQuickStatistics.vue?vue&type=template&id=452f0548&scoped=true&", function () {
      api.rerender('452f0548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comparison/SimpleQuickStatistics.vue"
export default component.exports